import { TColors } from '@cian/ui-kit-design-tokens/colors';
import { TLabelType } from '../../../../types/specialPromos/specialPromos';

export const LABEL_BACKGROUNDS: Record<TLabelType, TColors> = {
  mortgage: 'accent-main-secondary',
  sale: 'accent-main-secondary',
  newbuildingCount: 'overlay-control-default',
  discount: 'surface-positive-default',
  bonus: 'surface-warning-default',
};

export const LABEL_COLORS: Record<TLabelType, TColors> = {
  mortgage: 'accent-main-primary',
  sale: 'accent-main-primary',
  newbuildingCount: 'theme-dark',
  discount: 'accent-positive-primary',
  bonus: 'theme-orange',
};
